import React from "react";

// TODO: reemplazar por el componente real cuando esté listo
const Loaders = ({ options }) => (
  <span className="btn-loader" aria-hidden="true" />
);

// TODO: esto vendrá de DB / contexto global
const loaderdb = false;

const MainButton = ({ options = {} }) => {
  const {
    icon_left,
    icon_right, // preparado aunque hoy no se use
    main_btn_heading,
    main_btn_container_classes = "",
    main_btn_classes = "",
    main_btn_loader,
    main_handleClick,
  } = options;

  const isLoading = Boolean(main_btn_loader && main_btn_loader === loaderdb);

  const handleClick = (e) => {
    if (!main_handleClick || isLoading) return;
    e.preventDefault();
    main_handleClick(e);
  };

  return (
    <div className={main_btn_container_classes}>
      <button
        type="button"
        className={`t-pr btn t-border-r05 ${main_btn_classes}`}
        onClick={handleClick}
        disabled={isLoading}
        aria-busy={isLoading}
      >
        {icon_left?.icon && (
          <i className={`${icon_left.icon} t-pr-05`} aria-hidden="true" />
        )}

        <span>{main_btn_heading}</span>

        {icon_right?.icon && (
          <i className={`${icon_right.icon} t-pl-05`} aria-hidden="true" />
        )}

        {isLoading && <Loaders options={{ version: "loader_btn" }} />}
      </button>
    </div>
  );
};

export default MainButton;
